<script>
import Tabs from 'element-ui/lib/tabs';

Tabs.props.updateOnChange = String;

Tabs.watch.updateOnChange = function updateOnChange() {
  this.$forceUpdate();
};

// overriding the element-ui tab-bar.vue component
Tabs.components.TabNav.components.TabBar.computed.barStyle = {
  cache: false,
  get() {
    const $tabs = this.$parent.$refs.tabs;
    if (!$tabs) return {};

    const style = {};
    let offset = 0;
    let tabSize = 0;
    const sizeName =
      ['top', 'bottom'].indexOf(this.rootTabs.tabPosition) !== -1
        ? 'width'
        : 'height';
    const sizeDir = sizeName === 'width' ? 'x' : 'y';
    const firstUpperCase = str =>
      str.toLowerCase().replace(/( |^)[a-z]/g, L => L.toUpperCase());
    const direction = this.getTabDirection($tabs);

    this.tabs.every((tab, index) => {
      const $el = $tabs[index];
      if (!$el) {
        return false;
      }

      if (!tab.active) {
        if (direction === 'ltr') {
          offset += $el[`client${firstUpperCase(sizeName)}`];
        } else {
          offset -= $el[`client${firstUpperCase(sizeName)}`];
        }
        return true;
      }

      tabSize = $el[`client${firstUpperCase(sizeName)}`];
      if (sizeName === 'width' && this.tabs.length > 1) {
        tabSize -= index === 0 || index === this.tabs.length - 1 ? 20 : 40;
      }
      return false;
    });

    if (sizeName === 'width' && offset !== 0) {
      if (direction === 'ltr') {
        offset += 20;
      } else {
        offset -= 20;
      }
    }

    const transform = `translate${firstUpperCase(sizeDir)}(${offset}px)`;
    style[sizeName] = `${tabSize}px`;
    style.msTransform = transform;
    style.webkitTransform = transform;
    style.transform = transform;

    return style;
  },
};

let tabBarMethods = Tabs.components.TabNav.components.TabBar.methods;

if (!tabBarMethods) {
  /* eslint-disable no-multi-assign */
  tabBarMethods = Tabs.components.TabNav.components.TabBar.methods = {};
}

tabBarMethods.getTabDirection = function getTabDirection(tabs) {
  let direction = 'ltr';

  if (tabs.length > 1) {
    const $prevTab = tabs[0];
    const $nextTab = tabs[1];

    if (
      $nextTab.getBoundingClientRect().left <
      $prevTab.getBoundingClientRect().left
    ) {
      direction = 'rtl';
    }
  }

  return direction;
};
export default Tabs;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/tabs.css';
@import '../../stylesheets/utils/utils';

.el-tabs {
  display: block;

  @include rtl() {
    &__nav {
      float: right;
    }

    .el-tabs__item {
      &:nth-child(2) {
        padding-left: 20px;
        padding-right: 0;
      }

      &:last-child {
        padding-left: 0;
        padding-right: 20px;
      }
    }

    &__active-bar {
      left: auto;
      right: 0;
    }
  }
}
</style>
